/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SubscriptionInfo { 
    status: SubscriptionInfo.StatusEnum;
    freePasses: number;
    installedPasses: number;
    /**
     * The plan\'s included transaction allowance before usage charges apply in the rolling 30-day window; legacy subscriptions report their included Shopify order allowance, and non-active subscriptions report the Free plan\'s allowance
     */
    freeTransactions: number;
    /**
     * Current usage against the transaction allowance in the rolling last 30 days; active subscriptions created before transaction billing report billable Shopify orders
     */
    transactions: number;
    usageCharges: number;
    cappedAmount: number;
    /**
     * Whether the usage projected from the last 30 days has reached 75% of the merchant\'s Shopify capped amount, or already exceeds it, in a way raising the cap would fix. False when the plan\'s own ceiling already clamps the charge, since a bigger cap changes nothing there. Graded from the same projection as the daily cap-risk email, so the two cannot disagree
     */
    isApproachingCappedAmount: boolean;
    /**
     * The capped amount to offer the merchant, or null when raising it is not the answer — the plan\'s own ceiling on Growth/Advanced, and null once the subscription already sits at it
     */
    suggestedCappedAmount: number | null;
    /**
     * The selected subscription type; for non-active subscriptions, use freePasses and freeTransactions for the effective Free plan allowances
     */
    type: SubscriptionInfo.TypeEnum;
}
export namespace SubscriptionInfo {
    export const StatusEnum = {
        Created: 'created',
        Pending: 'pending',
        Active: 'active',
        Failed: 'failed',
        Cancelled: 'cancelled',
        Declined: 'declined',
        Expired: 'expired',
        Frozen: 'frozen'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
    export const TypeEnum = {
        Free: 'free',
        Growth: 'growth',
        Advanced: 'advanced',
        Enterprise: 'enterprise'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


